import { render, staticRenderFns } from "./PersonalResourceCard.vue?vue&type=template&id=78f64b51&scoped=true"
import script from "./PersonalResourceCard.vue?vue&type=script&lang=js"
export * from "./PersonalResourceCard.vue?vue&type=script&lang=js"
import style0 from "./PersonalResourceCard.vue?vue&type=style&index=0&id=78f64b51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f64b51",
  null
  
)

export default component.exports